export const ACTION_PREFIX = 'MODULE/COLOR_SELECTION'
